<div class="sidenav-content" cdkScrollable *ngIf="!submitting && !isLoading; else spinner">
	<copo-panel-header [isBackButtonVisible]="true" (backButtonClick)="goBack()"
		[titleHeaderText]="('guarantee.register'|translate) +' - '+ ('guarantee.organiccoating.long'|translate)">
		<button type="button" mat-flat-button (click)="saveGuarantee($event)">
			<span translate>issue.save.as.drafts</span>
			<mat-icon iconPositionEnd class="save-icon" svgIcon="action_save"></mat-icon>
		</button>
		<button mat-flat-button type="button" color="primary" (click)="goToNextStep($event)">
			<span translate>issue.select.batches.action.next</span>
		</button>
	</copo-panel-header>
	<form>
		<div class="copo-form-container copo-grid">
			<copo-stepper class="copo-stepper-container" [steps]="steps"></copo-stepper>
			<copo-feedback-error></copo-feedback-error>
			<div class="copo-grid-row ">
				<div class="copo-grid-row-column">
					<h2 translate>guarantee.customer.information</h2>
				</div>
			</div>
			<div class="copo-grid-row grid-template-columns">
				<div class="copo-grid-row-column" #nameDiv>
					<mat-form-field>
						<mat-label translate>guarantee.project.name</mat-label>
						<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="35"
							[formControl]="projectNameFormControl" (change)="projectNameChanged($event)" required>
						<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
						</mat-icon>
						<mat-error *ngIf="projectNameFormControl.hasError('required')"><span
								translate>guarantee.project.name.mandatory</span>
						</mat-error>
					</mat-form-field>
				</div>
				<div class="copo-grid-row-column" #soldToDiv>
					<mat-form-field>
						<mat-label translate>guarantee.customer.name</mat-label>
						<mat-select (selectionChange)="soldToChanged($event)" [formControl]="soldToFormControl"
							required>
							<mat-option *ngFor="let corporate of soldTos" [value]="corporate.businessId">
								{{corporate.name}}
							</mat-option>
						</mat-select>
						<mat-error *ngIf="soldToFormControl.hasError('required')"><span
								translate>guarantee.corporate.name.mandatory</span>
						</mat-error>
					</mat-form-field>
				</div>
			</div>
			<div class="copo-grid-row">
				<div class="copo-grid-row-column">
					<h2 translate>guarantee.project.characteristics</h2>
				</div>
			</div>
			<div class="copo-grid-row">
				<div class="copo-grid-row-column">
					<span class="copo-label" translate>guarantee.planned.operations</span>
				</div>
			</div>
			<div class="copo-grid-row">
				<mat-radio-group [formControl]="selectedOption" (change)="radioSelectionChanged($event.value)">
					<div class="copo-grid-row-column">
						<mat-radio-button class="mat-radio-button-guarantee" value="newBuildingCompleteConstruction">
							<span translate>guarantee.construction.new.building</span>
						</mat-radio-button>
					</div>
					<div class="copo-grid-row-column">
						<mat-radio-button class="mat-radio-button-guarantee" value="extensionExistingBuilding">
							<span translate>guarantee.extension.existing.building</span>
						</mat-radio-button>
					</div>
					<div class="copo-grid-row-column">
						<mat-radio-button class="mat-radio-button-guarantee" value="retrofittingRepairExistingBuilding">
							<span translate>guarantee.retrofitting.existing.building</span>
						</mat-radio-button>
					</div>
				</mat-radio-group>
				<div class="copo-grid-row-column">
					<ng-container *ngIf="selectedOption.value === 'retrofittingRepairExistingBuilding'">
						<div class="copo-grid-row-column">
							<div class="copo-grid-row">
								<mat-form-field class="copo-grid-row-column copo-input-width">
									<mat-label translate>guarantee.reason
									</mat-label>
									<input type="text" matInput spellcheck="false" autocomplete="off"
										maxlength="100" [formControl]="reasonFormControl"
										(change)="reasonChanged($event)">
									<mat-icon matSuffix color="accent" svgIcon="copo_pencil"
										class="image-draft-list-icon">
									</mat-icon>
								</mat-form-field>
							</div>
							<div class="copo-grid-row">
								<mat-form-field class="copo-grid-row-column copo-input-width">
									<mat-label translate>guarantee.nature.material
									</mat-label>
									<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="40"
										[formControl]="natureMaterialFormControl"
										(change)="natureMaterialChanged($event)">
									<mat-icon matSuffix color="accent" svgIcon="copo_pencil"
										class="image-draft-list-icon">
									</mat-icon>
								</mat-form-field>
							</div>
							<div class="copo-grid-row">
								<mat-form-field class="copo-grid-row-column copo-input-width">
									<mat-label translate>guarantee.condition.material
									</mat-label>
									<input type="text" matInput spellcheck="false" autocomplete="off"
										maxlength="100" [formControl]="conditionMaterialFormControl"
										(change)="conditionMaterialChanged($event)">
									<mat-icon matSuffix color="accent" svgIcon="copo_pencil"
										class="image-draft-list-icon">
									</mat-icon>
								</mat-form-field>
							</div>
							<div class="copo-grid-row">
								<mat-form-field class="copo-grid-row-column copo-input-width">
									<mat-label translate>guarantee.age.material
									</mat-label>
									<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="2"
										[formControl]="ageMaterialFormControl"
										(change)="ageMaterialChanged($event)">
									<mat-icon matSuffix color="accent" svgIcon="copo_pencil"
										class="image-draft-list-icon">
									</mat-icon>
								</mat-form-field>
							</div>
						</div>
					</ng-container>
				</div>
				<div class="copo-grid-row ">
					<div class="copo-grid-row-columns">
						<h2 class="copo-grid-row-header-top-margin" translate>guarantee.allocation.building</h2>
					</div>
					<div class="copo-grid-row-column">
						<mat-form-field class="copo-input-width copo-grid-row-column">
							<mat-label translate>guarantee.purpose.building</mat-label>
							<input type="text" matInput spellcheck="false" autocomplete="off"
								maxlength="100" [formControl]="otherADBSpecifyFormControl"
								(change)="otherADBSpecifyChanged($event)">
							<mat-icon matSuffix color="accent" svgIcon="copo_pencil"
								class="image-draft-list-icon">
							</mat-icon>
						</mat-form-field>
					</div>
				</div>
				<div class="copo-grid-row">
					<div class="copo-grid-row-column">
						<mat-checkbox labelPosition="after" [formControl]="residentialUseFormControl"
							(change)="residentialUseChanged($event.checked)">
							<span class="checkbox-label-wrapped" translate>guarantee.residential</span>
						</mat-checkbox>
					</div>
				</div>
				<div class="copo-grid-row">
					<div class="copo-grid-row-column">
						<mat-checkbox labelPosition="after" [formControl]="industrialFormControl"
							(change)="industrialChanged($event.checked)">
							<span class="checkbox-label-wrapped" translate>guarantee.industrial</span>
						</mat-checkbox>
					</div>
				</div>
				<div class="copo-grid-row">
					<div class="copo-grid-row-column">
						<mat-checkbox labelPosition="after" [formControl]="agriculturalFormControl"
							(change)="agriculturalChanged($event.checked)">
							<span class="checkbox-label-wrapped" translate>guarantee.agricultural</span>
						</mat-checkbox>
					</div>
				</div>
				<div class="copo-grid-row">
					<div class="copo-grid-row-column">
						<mat-checkbox labelPosition="after" [formControl]="otherADBFormControl"
							(change)="otherADBChanged($event.checked)">
							<span class="checkbox-label-wrapped" translate>guarantee.other.building</span>
						</mat-checkbox>
					</div>
				</div>
				<mat-radio-group name="building" class="copo-guarantee-radio-group" labelPosition="after"
					[formControl]="buildingsFormControl" (change)="buildingsChanged($event)">
					<div class="copo-grid-row-column">
						<mat-radio-button name="building" class="copo-guarantee-checkbox-placement" value="industrial">
							<span class="checkbox-label-wrapped" translate>guarantee.industrial.questions</span>
						</mat-radio-button>
						<ng-container *ngIf="buildingsFormControl.value === 'industrial'">
							<div class="copo-grid-row-column-top-margin">
								<div class="copo-grid-row-column">
										<mat-form-field class="copo-grid-row-column">
											<mat-label translate>guarantee.inside-building.activity</mat-label>
											<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="100"
												[formControl]="acitivityInsideBuildingFormControl"
												(change)="acitivityInsideBuildingChanged($event)">
											<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
											</mat-icon>
										</mat-form-field>
								</div>
								<div class="copo-grid-container">
									<span class="copo-grid-column" translate>guarantee.storage.chemicals</span>
									<mat-radio-group class="copo-guarantee-radio-group" labelPosition="before"
										[formControl]="presenceofChemicalFormControl"
										(change)="presenceofChemicalChanged($event)">
										<mat-radio-button class="copo-guarantee-radio" value="true">
											<span translate>guarantee.radio.yes</span>
										</mat-radio-button>
										<mat-radio-button class="copo-guarantee-radio" value="false">
											<span translate>guarantee.radio.no</span>
										</mat-radio-button>
										<mat-radio-button class="copo-guarantee-radio" value="">
											<span translate>guarantee.radio.na</span>
										</mat-radio-button>
									</mat-radio-group>
									<ng-container *ngIf="presenceofChemicalFormControl.value === 'true'">
										<mat-form-field class="copo-grid-row-column left-margin">
											<mat-label translate>guarantee.nature.content</mat-label>
											<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="20"
												[formControl]="natureContentFormControl" (change)="natureContentChanged($event)">
											<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
											</mat-icon>
										</mat-form-field>
									</ng-container>
								</div>
								<div class="copo-grid-container">
									<span class="copo-grid-column" translate>guarantee.storage.fermentation</span>
									<mat-radio-group class="copo-guarantee-radio-group" labelPosition="before"
										[formControl]="presenceofFermentationFormControl"
										(change)="presenceofFermentationChanged($event)">
										<mat-radio-button class="copo-guarantee-radio" value="true">
											<span translate>guarantee.radio.yes</span>
										</mat-radio-button>
										<mat-radio-button class="copo-guarantee-radio" value="false">
											<span translate>guarantee.radio.no</span>
										</mat-radio-button>
										<mat-radio-button class="copo-guarantee-radio" value="">
											<span translate>guarantee.radio.na</span>
										</mat-radio-button>
									</mat-radio-group>
									<ng-container *ngIf="presenceofFermentationFormControl.value === 'true'">
										<mat-form-field class="copo-grid-row-column left-margin">
											<mat-label translate>guarantee.nature.content</mat-label>
											<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="20"
												[formControl]="natureContent2FormControl" (change)="natureContent2Changed($event)">
											<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
											</mat-icon>
										</mat-form-field>
									</ng-container>
								</div>
								<div class="copo-grid-container">
									<span class="copo-grid-column" translate>guarantee.gas.building</span>
									<mat-radio-group class="copo-guarantee-radio-group" labelPosition="before"
										[formControl]="gasVapourFormControl" (change)="gasVapourChanged($event)">
										<mat-radio-button class="copo-guarantee-radio" value="true">
											<span translate>guarantee.radio.yes</span>
										</mat-radio-button>
										<mat-radio-button class="copo-guarantee-radio" value="false">
											<span translate>guarantee.radio.no</span>
										</mat-radio-button>
										<mat-radio-button class="copo-guarantee-radio" value="">
											<span translate>guarantee.radio.na</span>
										</mat-radio-button>
									</mat-radio-group>
									<ng-container *ngIf="gasVapourFormControl.value === 'true'">
										<mat-form-field class="copo-grid-row-column left-margin">
											<mat-label translate>guarantee.nature.content</mat-label>
											<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="20"
												[formControl]="gasvaporNatureContentFormControl"
												(change)="gasvaporNatureContentChanged($event)">
											<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
											</mat-icon>
										</mat-form-field>
									</ng-container>
								</div>
								<div class="copo-grid-container copo-margin-bottom">
									<span class="copo-grid-column" translate>guarantee.building.heated</span>
									<mat-radio-group class="copo-guarantee-radio-group" labelPosition="before"
										[formControl]="buildingHeatedFormControl" (change)="buildingHeatedChanged($event)">
										<mat-radio-button class="copo-guarantee-radio" value="true">
											<span translate>guarantee.radio.yes</span>
										</mat-radio-button>
										<mat-radio-button class="copo-guarantee-radio" value="false">
											<span translate>guarantee.radio.no</span>
										</mat-radio-button>
										<mat-radio-button class="copo-guarantee-radio" value="">
											<span translate>guarantee.radio.na</span>
										</mat-radio-button>
									</mat-radio-group>
									<ng-container *ngIf="buildingHeatedFormControl.value === 'true'">
										<mat-form-field class="copo-grid-row-column left-margin">
											<mat-label translate>guarantee.heating.type
											</mat-label>
											<input type="text" matInput spellcheck="false" autocomplete="off" maxlength="20"
												[formControl]="heatingTypeFormControl" (change)="heatingTypeChanged($event)">
											<mat-icon matSuffix color="accent" svgIcon="copo_pencil" class="image-draft-list-icon">
											</mat-icon>
										</mat-form-field>
									</ng-container>
								</div>
								<div class="copo-grid-row-column">
									<div class="checkbox-label-wrapped que-equipment" translate>guarantee.equipment</div>
									<div class="copo-grid-row-column copo-radio-top-margin">
										<div class="copo-grid-row-column">
											<mat-checkbox labelPosition="after" [formControl]="qiaExtractorFormControl"
												(change)="qiaExtractorChanged($event.checked)">
												<span class="checkbox-label-wrapped" translate>guarantee.extractor</span>
											</mat-checkbox>
										</div>
										<div class="copo-grid-row-column">
											<mat-checkbox labelPosition="after" [formControl]="qiaChimneyFormControl"
												(change)="qiaChimneyChanged($event.checked)">
												<span class="checkbox-label-wrapped" translate>guarantee.chimney</span>
											</mat-checkbox>
										</div>
										<div class="copo-grid-row-column">
											<mat-checkbox labelPosition="after"
												[formControl]="qiaNaturalventilationFormControl"
												(change)="qiaNaturalventilationChanged($event.checked)">
												<span class="checkbox-label-wrapped"
													translate>guarantee.natural.ventilation</span>
											</mat-checkbox>
										</div>
										<div class="copo-grid-row-column">
											<mat-checkbox labelPosition="after"
												[formControl]="qiaForcedventilationFormControl"
												(change)="qiaForcedventilationChanged($event.checked)">
												<span class="checkbox-label-wrapped"
													translate>guarantee.forced.ventilation</span>
											</mat-checkbox>
										</div>
										<div class="copo-grid-row-column">
											<mat-checkbox labelPosition="after"
												[formControl]="otherEquipmentFormControl"
												(change)="otherEquipmentChanged($event.checked)">
												<span class="checkbox-label-wrapped" translate>claim.sample.other
												</span>
											</mat-checkbox>
											<ng-container *ngIf="otherEquipmentFormControl.value === true">
												<div class="copo-grid-row-column">
													<mat-form-field>
														<mat-label translate>guarantee.specify</mat-label>
														<input type="text" matInput spellcheck="false" autocomplete="off"
															maxlength="20" [formControl]="specifyOtherEquipmentFormControl"
															(change)="specifyOtherEquipmentChanged($event)">
														<mat-icon matSuffix color="accent" svgIcon="copo_pencil"
															class="image-draft-list-icon">
														</mat-icon>
													</mat-form-field>
												</div>
											</ng-container>
										</div>
									</div>
								</div>
								<div class="copo-grid-row-column humidity-align">
									<span translate>guarantee.humidity.rate.inside.building</span>
									<mat-radio-group class="copo-grid-row-column" labelPosition="before"
										[formControl]="buildingHumidityRateFormControl" (change)="buildingHumidityRateChanged($event)">
										<div class="copo-grid-row-column copo-radio-top-margin">
											<mat-radio-button class="copo-guarantee-radio" [value]="humidityRate.low">
												<span class="humidity" translate>guarantee.humidity.low</span>
											</mat-radio-button>
										</div>
										<div class="copo-grid-row-column copo-radio-top-margin">
											<mat-radio-button class=" copo-guarantee-radio" [value]="humidityRate.medium">
												<span class="humidity" translate>guarantee.humidity.medium</span>
											</mat-radio-button>
										</div>
										<div class="copo-grid-row-column copo-radio-top-margin">
											<mat-radio-button class=" copo-guarantee-radio" [value]="humidityRate.high">
												<span class="humidity" translate>guarantee.humidity.high</span>
											</mat-radio-button>
										</div>
										<div class="copo-grid-row-column copo-radio-top-margin">
											<mat-radio-button class=" copo-guarantee-radio" [value]="humidityRate.veryHigh">
												<span class="humidity" translate>guarantee.humidity.very.high</span>
											</mat-radio-button>
										</div>
										<div class="copo-grid-row-column copo-radio-top-margin">
											<mat-radio-button class=" copo-guarantee-radio" [value]="humidityRate.saturated">
												<span translate class="humidity">guarantee.humidity.saturated</span>
											</mat-radio-button>
										</div>
									</mat-radio-group>
								</div>
								<div class="copo-grid-container">
									<span class="copo-grid-column" translate>guarantee.condensation.rink</span>
									<mat-radio-group class="copo-guarantee-radio-group" labelPosition="before"
										[formControl]="qiacondriskbuildingFormControl"
										(change)="qiacondriskbuildingChanged($event)">
										<mat-radio-button class="copo-guarantee-radio" value="true">
											<span translate>guarantee.radio.yes</span>
										</mat-radio-button>
										<mat-radio-button class="copo-guarantee-radio" value="false">
											<span translate>guarantee.radio.no</span>
										</mat-radio-button>
										<mat-radio-button class="copo-guarantee-radio" value="">
											<span translate>guarantee.radio.na</span>
										</mat-radio-button>
									</mat-radio-group>
								</div>
							</div>
						</ng-container>
					</div>
					<div class="copo-grid-row-column">
						<mat-radio-button name="building" class="copo-guarantee-checkbox-placement" value="agricultural">
							<span class="checkbox-label-wrapped" translate>guarantee.agricultural.questions</span>
						</mat-radio-button>
						<ng-container *ngIf="buildingsFormControl.value === 'agricultural'">
							<div class="copo-grid-row-column-top-margin">
								<div class="copo-grid-row-column">
									<mat-checkbox [formControl]="activityAgriculturalBuildingFormControl"
										(change)="activityAgriculturalChanged($event.checked)">
										<span class="checkbox-label-wrapped" translate>guarantee.activity.building</span>
									</mat-checkbox>
									<div class="copo-grid-row-column">
										<ng-container *ngIf="activityAgriculturalBuildingFormControl.value === true">
											<div class="copo-grid-row-column copo-radio-top-margin">
												<mat-checkbox labelPosition="after" [formControl]="storageFodderFormControl"
													(change)="storageFodderChanged($event.checked)">
													<span class="checkbox-label-wrapped" translate>guarantee.fodder</span>
												</mat-checkbox>
											</div>
											<div class="copo-grid-row-column">
												<mat-checkbox labelPosition="after"
													[formControl]="storageFertilizerFormControl"
													(change)="storageFertilizerChanged($event.checked)">
													<span class="checkbox-label-wrapped" translate>guarantee.fertilizer</span>
												</mat-checkbox>
											</div>
											<div class="copo-grid-row-column copo-margin-bottom">
												<mat-checkbox labelPosition="after"
													[formControl]="breedingAnimalsFormControl"
													(change)="breedingAnimalsChanged($event.checked)">
													<span class="checkbox-label-wrapped" translate>guarantee.breeding.animals</span>
												</mat-checkbox>
												<div class="copo-grid-row-column">
													<ng-container *ngIf="breedingAnimalsFormControl.value === true">
														<div class="copo-grid-row-column copo-radio-top-margin">
															<mat-checkbox labelPosition="after"
																[formControl]="cattleFormControl"
																(change)="cattleChanged($event.checked)">
																<span class="checkbox-label-wrapped"
																	translate>guarantee.cattle</span>
															</mat-checkbox>
														</div>
														<div class="copo-grid-row-column">
															<mat-checkbox labelPosition="after"
																[formControl]="pigsFormControl"
																(change)="pigsChanged($event.checked)">
																<span class="checkbox-label-wrapped"
																	translate>guarantee.pigs</span>
															</mat-checkbox>
														</div>
														<div class="copo-grid-row-column">
															<mat-checkbox labelPosition="after"
																[formControl]="polutryFormControl"
																(change)="polutryChanged($event.checked)">
																<span class="checkbox-label-wrapped"
																	translate>guarantee.Poultry</span>
															</mat-checkbox>
														</div>
														<div class="copo-grid-row-column">
															<mat-checkbox labelPosition="after"
																[formControl]="otherAnimalsFormControl"
																(change)="otherAnimalsChanged($event.checked)">
																<span class="checkbox-label-wrapped"
																	translate>guarantee.others.animals</span>
															</mat-checkbox>
															<ng-container *ngIf="otherAnimalsFormControl.value === true">
																<div class="copo-grid-row-column">
																	<mat-form-field class="copo-input-width">
																		<mat-label
																			translate>guarantee.animals.inside.building
																		</mat-label>
																		<input type="text" matInput spellcheck="false"
																			autocomplete="off" maxlength="20"
																			[formControl]="animalsInsideBuildingFormControl"
																			(change)="animalsInsideBuildingChanged($event)">
																		<mat-icon matSuffix color="accent"
																			svgIcon="copo_pencil"
																			class="image-draft-list-icon">
																		</mat-icon>
																	</mat-form-field>
																</div>
															</ng-container>
															<div class="copo-grid-row-column">
																<mat-form-field class="copo-input-width">
																	<mat-label translate>guarantee.animals.shed</mat-label>
																	<input type="text" matInput
																		spellcheck="false" autocomplete="off" maxlength="10"
																		[formControl]="animalsinShedFormControl"
																		(change)="animalsinShedChanged($event)">
																	<mat-icon matSuffix color="accent" svgIcon="copo_pencil"
																		class="image-draft-list-icon">
																	</mat-icon>
																</mat-form-field>
															</div>
															<div class="copo-grid-row-column">
																<mat-form-field class="copo-input-width">
																	<mat-label
																		translate>guarantee.animals.density</mat-label>
																	<input type="text" matInput copoInputNumber
																		spellcheck="false" autocomplete="off" maxlength="5"
																		[formControl]="densityofAnimalsFormControl"
																		(change)="densityofAnimalsChanged($event)">
																	<mat-icon matSuffix color="accent" svgIcon="copo_pencil"
																		class="image-draft-list-icon">
																	</mat-icon>
																</mat-form-field>
															</div>
															<div class="copo-grid-row-column">
																<mat-checkbox [formControl]="manureManagementFormControl"
																	class="copo-guarantee-checkbox-placement"
																	(change)="manureManagementChanged($event.checked)">
																	<span class="checkbox-label-wrapped"
																		translate>guarantee.manure.management</span>
																</mat-checkbox>
																<ng-container *ngIf="manureManagementFormControl.value === true">
																	<div class="copo-grid-row-column copo-radio-top-margin">
																		<div class="copo-grid-row-column">
																			<mat-checkbox labelPosition="after"
																				[formControl]="manureManagementConcreteGratingDuckboardFormControl"
																				(change)="manureManagementConcreteGratingDuckboardChanged($event.checked)">
																				<span
																					class="checkbox-label-wrapped" translate>guarantee.duckboard</span>
																			</mat-checkbox>
																		</div>
																		<div class="copo-grid-row-column">
																			<mat-checkbox labelPosition="after"
																				[formControl]="manureManagementNoDuckboardFormControl"
																				(change)="manureManagementNoDuckboardChanged($event.checked)">
																				<span
																					class="checkbox-label-wrapped" translate>guarantee.no.duckboard</span>
																			</mat-checkbox>
																		</div>
																	</div>
																</ng-container>
															</div>
														</div>
													</ng-container>
												</div>
											</div>
										</ng-container>
									</div>
								</div>
								<div class="copo-grid-row-column">
									<mat-checkbox [formControl]="ambienceBuildingFormControl"
										(change)="ambienceChanged($event.checked)">
										<span class="checkbox-label-wrapped" translate>guarantee.ambiance</span>
									</mat-checkbox>
									<div class="copo-grid-row-column">
										<ng-container *ngIf="ambienceBuildingFormControl.value === true">
											<div class="copo-grid-row-column copo-radio-top-margin">
												<div class="checkbox-label-wrapped que-equipment" translate>guarantee.equipment</div>
												<div class="copo-grid-row-column copo-radio-top-margin">
													<mat-checkbox labelPosition="after"
														[formControl]="naturalVentilationFormControl"
														(change)="naturalVentilationChanged($event.checked)">
														<span class="checkbox-label-wrapped" translate>guarantee.ventilation.walls</span>
													</mat-checkbox>
												</div>
												<div class="copo-grid-row-column">
													<mat-checkbox labelPosition="after"
														[formControl]="naturalVentilationRoofFormControl"
														(change)="naturalVentilationRoofChanged($event.checked)">
														<span class="checkbox-label-wrapped" translate>guarantee.ventilation.roof</span>
													</mat-checkbox>
												</div>
												<div class="copo-grid-row-column">
													<mat-checkbox labelPosition="after"
														[formControl]="forcedVentilationFormControl"
														(change)="forcedVentilationChanged($event.checked)">
														<span class="checkbox-label-wrapped" translate>guarantee.forced.ventilation</span>
													</mat-checkbox>
												</div>
												<div class="copo-grid-row-column">
													<mat-checkbox labelPosition="after"
														[formControl]="otherVentilationFormControl"
														(change)="otherVentilationChanged($event.checked)">
														<span class="checkbox-label-wrapped"
															translate>guarantee.others.animals</span>
													</mat-checkbox>
													<ng-container *ngIf="otherVentilationFormControl.value === true">
														<div class="copo-grid-row-column">
															<mat-form-field class="copo-specify-width">
																<mat-label translate>guarantee.agricultural.specify
																</mat-label>
																<input type="text" matInput spellcheck="false"
																	autocomplete="off" maxlength="40"
																	[formControl]="otherVentilationSpecifyFormControl"
																	(change)="otherVentilationSpecifyChanged($event)">
																<mat-icon matSuffix color="accent" svgIcon="copo_pencil"
																	class="image-draft-list-icon">
																</mat-icon>
															</mat-form-field>
														</div>
													</ng-container>
													<div class="copo-grid-row-column">
														<mat-form-field class="copo-specify-width">
															<mat-label translate>guarantee.air.renewal</mat-label>
															<input type="text" matInput
																spellcheck="false" autocomplete="off" maxlength="10"
																[formControl]="airRenewalFormControl"
																(change)="airRenewalChanged($event)">
															<mat-icon matSuffix color="accent" svgIcon="copo_pencil"
																class="image-draft-list-icon">
															</mat-icon>
														</mat-form-field>
													</div>
													<div class="copo-grid-row-column">
														<mat-form-field class="copo-specify-width">
															<mat-label translate>guarantee.ammonia</mat-label>
															<input type="text" matInput
																spellcheck="false" autocomplete="off" maxlength="10"
																[formControl]="ammoniaFormControl"
																(change)="ammoniaChanged($event)">
															<mat-icon matSuffix color="accent" svgIcon="copo_pencil"
																class="image-draft-list-icon">
															</mat-icon>
														</mat-form-field>
													</div>
													<div class="copo-grid-row-column">
														<mat-form-field class="copo-specify-width">
															<mat-label translate>guarantee.hydrogen.sulphide</mat-label>
															<input type="text" matInput
																spellcheck="false" autocomplete="off" maxlength="10"
																[formControl]="hydrogenSulphideFormControl"
																(change)="hydrogenSulphideChanged($event)">
															<mat-icon matSuffix color="accent" svgIcon="copo_pencil"
																class="image-draft-list-icon">
															</mat-icon>
														</mat-form-field>
													</div>
												</div>
											</div>
											<div class="copo-grid-row-column humidity-align">
												<span translate>guarantee.humidity.rate.inside.building</span>
												<mat-radio-group class="copo-grid-row-column" labelPosition="before"
													[formControl]="buildingHumidityRateFormControl" (change)="buildingHumidityRateChanged($event)">
													<div class="copo-grid-row-column copo-radio-top-margin">
														<mat-radio-button class="copo-guarantee-radio" [value]="humidityRate.low">
															<span class="humidity" translate>guarantee.humidity.low</span>
														</mat-radio-button>
													</div>
													<div class="copo-grid-row-column copo-radio-top-margin">
														<mat-radio-button class=" copo-guarantee-radio" [value]="humidityRate.medium">
															<span class="humidity" translate>guarantee.humidity.medium</span>
														</mat-radio-button>
													</div>
													<div class="copo-grid-row-column copo-radio-top-margin">
														<mat-radio-button class=" copo-guarantee-radio" [value]="humidityRate.high">
															<span class="humidity" translate>guarantee.humidity.high</span>
														</mat-radio-button>
													</div>
													<div class="copo-grid-row-column copo-radio-top-margin">
														<mat-radio-button class=" copo-guarantee-radio" [value]="humidityRate.veryHigh">
															<span class="humidity" translate>guarantee.humidity.very.high</span>
														</mat-radio-button>
													</div>
													<div class="copo-grid-row-column copo-radio-top-margin">
														<mat-radio-button class=" copo-guarantee-radio" [value]="humidityRate.saturated">
															<span translate class="humidity">guarantee.humidity.saturated</span>
														</mat-radio-button>
													</div>
												</mat-radio-group>
												<div class="copo-grid-row-column">
													<mat-form-field>
														<mat-label translate>guarantee.humidity.specify</mat-label>
														<input type="text" matInput spellcheck="false"
															autocomplete="off" maxlength="3" [formControl]="humidityFormControl"
															(change)="humidityChanged($event)">
														<mat-icon matSuffix color="accent" svgIcon="copo_pencil"
															class="image-draft-list-icon">
														</mat-icon>
													</mat-form-field>
												</div>
											</div>
											<div class="copo-grid-container">
												<span class="copo-grid-column" translate>guarantee.condensation.rink</span>
												<mat-radio-group class="copo-guarantee-radio-group" labelPosition="before"
													[formControl]="qiacondriskbuildingFormControl"
													(change)="qiacondriskbuildingChanged($event)">
													<mat-radio-button class="copo-guarantee-radio" value="true">
														<span translate>guarantee.radio.yes</span>
													</mat-radio-button>
													<mat-radio-button class="copo-guarantee-radio" value="false">
														<span translate>guarantee.radio.no</span>
													</mat-radio-button>
													<mat-radio-button class="copo-guarantee-radio" value="">
														<span translate>guarantee.radio.na</span>
													</mat-radio-button>
												</mat-radio-group>
											</div>
										</ng-container>
									</div>
								</div>
							</div>
						</ng-container>
					</div>
				</mat-radio-group>
			</div>
		</div>
	</form>
</div>
<ng-template #spinner>
	<copo-loading-spinner class="loading-spinner-container-padded"></copo-loading-spinner>
</ng-template>